var HorizonJs_Uuid = /** @class */ (function () {
    function HorizonJs_Uuid(obj) {
        if (obj === void 0) { obj = {}; }
    }
    HorizonJs_Uuid.isValid = function (str) {
        if (str.length !== 36)
            return false;
        str = str.toLowerCase();
        var match = str.match(new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i));
        return match !== null;
    };
    HorizonJs_Uuid.isValidUuid = function (uuid) {
        var uuidRegex = new RegExp("[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}");
        return uuidRegex.test(uuid);
    };
    HorizonJs_Uuid.bytesToUuid = function (buf, offset) {
        if (offset === void 0) { offset = 0; }
        var i = offset || 0;
        // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
        return ([HorizonJs_Uuid.byteToHex[buf[i++]], HorizonJs_Uuid.byteToHex[buf[i++]],
            HorizonJs_Uuid.byteToHex[buf[i++]], HorizonJs_Uuid.byteToHex[buf[i++]], '-',
            HorizonJs_Uuid.byteToHex[buf[i++]], HorizonJs_Uuid.byteToHex[buf[i++]], '-',
            HorizonJs_Uuid.byteToHex[buf[i++]], HorizonJs_Uuid.byteToHex[buf[i++]], '-',
            HorizonJs_Uuid.byteToHex[buf[i++]], HorizonJs_Uuid.byteToHex[buf[i++]], '-',
            HorizonJs_Uuid.byteToHex[buf[i++]], HorizonJs_Uuid.byteToHex[buf[i++]],
            HorizonJs_Uuid.byteToHex[buf[i++]], HorizonJs_Uuid.byteToHex[buf[i++]],
            HorizonJs_Uuid.byteToHex[buf[i++]], HorizonJs_Uuid.byteToHex[buf[i++]]]).join('');
    };
    HorizonJs_Uuid.rng = function () {
        var bytes8 = new Int8Array(16);
        crypto.getRandomValues(bytes8);
        var bytes = [];
        for (var i = 0; i < 16; ++i)
            bytes.push(bytes8[i] + 128);
        return bytes;
    };
    HorizonJs_Uuid.v4 = function () {
        var rnds = HorizonJs_Uuid.rng();
        rnds[6] = (rnds[6] & 0x0f) | 0x40;
        rnds[8] = (rnds[8] & 0x3f) | 0x80;
        return HorizonJs_Uuid.bytesToUuid(rnds);
    };
    HorizonJs_Uuid.convertToUuid36 = function (str) {
        if (str.length === 32) {
            str = str.substr(0, 8)
                + '-' + str.substr(8, 4)
                + '-' + str.substr(12, 4)
                + '-' + str.substr(16, 4)
                + '-' + str.substr(20, 12);
        }
        else if (str.length !== 36)
            throw new Error('str_doesnt_match_uuid_without_dashes');
        console.log(str);
        if (!this.isValid(str))
            throw new Error('invalid_uuid');
        return str;
    };
    HorizonJs_Uuid.byteToHex = [];
    return HorizonJs_Uuid;
}());
export { HorizonJs_Uuid };
for (var i = 0; i < 256; ++i) {
    HorizonJs_Uuid.byteToHex[i] = (i + 0x100).toString(16).substr(1);
}
//# sourceMappingURL=HorizonJs_Uuid.js.map